import { RootState } from '@app/redux/store';

export const getMinPrice = (state: RootState) => state.widgetFilter.minPrice;
export const getMaxPrice = (state: RootState) => state.widgetFilter.maxPrice;
